define("shared/utils/plans-data/feature-keys", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  //Note: featureKeys is a dictionary used to map items on the features Object within a subscription plan
  //where the key is what is used on the FE and the value is the key received from the BE
  const featureKeys = {
    accessGroups: 'groups',
    analyticsExport: 'analytics_export',
    analyticsReport: 'analytics_performance_report',
    analyticsStandard: 'analytics_standard',
    approvalFlow: 'approval_flow',
    bttp: 'bttp',
    calendarNotes: 'calendar_notes',
    campaignBoard: 'campaign_board',
    captionHashtags: 'caption_hashtags',
    chromeExtension: 'chrome_extension',
    collaborators: 'user_tagging',
    // Note: same as user_tagging
    competitiveBenchmarking: 'competitors_lists',
    contributors: 'contributors',
    conversations: 'social_inbox_igfb_dm',
    createMediaKit: 'create_media_kit',
    customAnalytics: 'custom_analytics_dashboard',
    draftPosts: 'draft_posts',
    facebookAnalytics: 'facebook_analytics',
    facebookReels: 'facebook_reels',
    filters: 'filters',
    firstComment: 'first_comment',
    futureInsights: 'future_insights',
    hashtagAnalytics: 'hashtag_analytics',
    hashtagSuggestions: 'hashtag_suggestions',
    hashtagTrends: 'hashtag_trends',
    igProductTagging: 'ig_product_tagging',
    igReelsAnalytics: 'ig_reels_analytics',
    igReelsScheduling: 'ig_reels_scheduling',
    influencerOptIn: 'influencer_opt_in',
    linkinbioBannerless: 'linkinbio_bannerless',
    linkinbioButtonColor: 'linkinbio_button_colour',
    linkinbioEmbeddable: 'linkinbio_embeddable',
    linkinbioExtendedClickAnalytics: 'linkinbio_extended_click_analytics',
    linkinbioFeaturedMediaImage: 'linkinbio_featured_media_image',
    linkinbioFeaturedMediaVideo: 'linkinbio_featured_media_embedded_video',
    linkinbioLinkedSocialPosts: 'linkinbio_many_linked_social_posts',
    linkinbioMailchimp: 'linkinbio_mailchimp',
    linkinbioSeo: 'linkinbio_seo',
    linkinbioTiktokPostSupport: 'linkinbio_tiktok_post_support',
    locationTagging: 'location_tagging',
    longerAnalytics: 'longer_analytics',
    mentionedMedia: 'collect_mentions',
    multiPhoto: 'multi_photo',
    multiProfileScheduling: 'multi_profile_scheduling',
    photos: 'photos',
    pinAnalytics: 'pinterest_analytics',
    pinterestClickTracking: 'pinterest_click_tracking',
    savedCaptions: 'saved_captions',
    searchByHashtag: 'collect_hashtags',
    searchByProfile: 'search_by_ig_profile',
    searchInfluencers: 'search_influencers',
    shareCalendar: 'schedule_sharing',
    stories: 'ig_stories_scheduling',
    supportDocs: 'support_docs',
    supportEmail: 'support_email',
    supportMessaging: 'support_messaging',
    taggedMedia: 'collect_tags',
    tagging: 'user_location_tagging',
    textOnImages: 'text_on_image',
    tiktok: 'tiktok',
    tiktokAnalytics: 'tiktok_analytics',
    tiktokConversations: 'social_inbox_igfb_dm',
    twAnalytics: 'twitter_analytics',
    twitterClickTracking: 'twitter_click_tracking',
    unlimitedMedia: 'unlimited_media',
    usePostActivityLog: 'use_post_activity_log',
    userTagging: 'user_tagging',
    videoCoverSelect: 'video_cover_select',
    videos: 'video',
    visualPlanner: 'visual_planner'
  };
  var _default = _exports.default = featureKeys;
});